import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-customer-approval',
  templateUrl: './customer-approval.component.html',
  styleUrls: ['./customer-approval.component.css']
})
export class CustomerApprovalComponent implements OnInit {

  CardShown=false;
  loaderShown=true;
  center!: google.maps.LatLngLiteral;
  markers:any=[];
  zoom = 12;
  CustomerApp:any=[];
  next_output:any=[];
  count=0;
  New_count=0;
  search:string='';
  customer:string='';
  employee:string='';
  data={
    _id:"",
    customer_id:"",
    customer_latitude:"",
    customer_longitude:"",
    status:""
  }
  map_lat:any="";
  map_log:any="";
  search_flag=false;
  constructor(private customerService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  FindLocation(lat:any,log:any){
    this.map_lat=lat;
    this.map_log=log;
    
    console.log("Find location");
    this.center = {
      lat:lat,
      lng:log
    };
   this.addMarker();
  }
  addMarker() {
    this.markers.push({
      position: {
        lat: this.center.lat,
        lng: this.center.lng,
      },
      label: {
        color: 'red',
        text: 'Customer location',
      },
      title: 'Customer location',
      options: { animation: google.maps.Animation.BOUNCE },
    });
    
  }
  //-------------function for search--------------------
Search(){

  this.employee=""
  this.count=0;
  this.New_count=0;
  console.log("customer search",this.search);
  
  this.loaderShown=true;
  this.CardShown=false;
  this.CustomerApp=[];
  if(this.search!='')
  {
  this.search_flag=true;
  this.customerService.CustomerAppSearch(this.count,this.search).subscribe((res)=>{
  this.CustomerApp=res.data
  console.log("output1=",this.CustomerApp)
  this.loaderShown=false;
  this.CardShown=true;
  })
 }
 else{
  this.search_flag=false;
  
   //-------api get()calling-------------
   this.customerService.GetCustomerApp(this.count).subscribe((res)=>{
    this.CustomerApp=res.data
    console.log("output2=",this.CustomerApp)
  //  this.Pagingflag=0

    this.loaderShown=false;
    this.CardShown=true;
    })

 }
}

Search_Employee(){
  
  this.search=""
  this.count=0;
  this.New_count=0;
  console.log("employee search",this.employee);
  
  this.loaderShown=true;
  this.CardShown=false;
  this.CustomerApp=[];
  if(this.employee!='')
  {
  this.search_flag=true;
  this.customerService.EmployeeAppSearch(this.count,this.employee).subscribe((res)=>{
  this.CustomerApp=res.data
  console.log("output1=",this.CustomerApp)
  this.loaderShown=false;
  this.CardShown=true;
  })
 }
 else{
  this.search_flag=false;
  
   //-------api get()calling-------------
   this.customerService.GetCustomerApp(this.count).subscribe((res)=>{
    this.CustomerApp=res.data
    console.log("output2=",this.CustomerApp)
  //  this.Pagingflag=0

    this.loaderShown=false;
    this.CardShown=true;
    })

 }
}
  //-------date formating-------------
  
  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe:any= null;
  DateFormat(value:any){

    //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
    return this.todayWithPipe

  }
  //-----function for approve---
  Approve(CId:any,Id:any,lat:any,log:any){
    this.CardShown=false;
    this.loaderShown=true;

    this.data.customer_id=CId;
    this.data._id=Id;
    this.data.customer_latitude=lat;
    this.data.customer_longitude=log;

    this.data.status="Approved";
    this.UpdateStatus(this.data);

  }
  //-----function for reject----------
  Reject(CId:any,Id:any,lat:any,log:any){
    this.CardShown=false;
    this.loaderShown=true;
    
    this.data.customer_id=CId;
    this.data._id=Id;
    this.data.customer_latitude=lat;
    this.data.customer_longitude=log;

    this.data.status="Rejected"
    this.UpdateStatus(this.data);
  }
  //----function for update status---------
  UpdateStatus(data:any){
    this.customerService.UpdateCustStatus(data).subscribe((res)=>{
      console.log("response=",res)
      if(this.employee!='')
      {
      this.Search_Employee();
      }
      else if(this.search!='')
      {
        this.Search();
      }

      else{
        this.ngOnInit();
      }
    //  this.ngOnInit();
    })

  }
  clicks_previous(){
    if(this.New_count==0){
      return;
    }
    else{
      this.New_count=this.New_count-1;
      this.count=this.New_count; 
    }
    if(this.search_flag==false){
    this.customerService.GetCustomerApp(this.count).subscribe((res)=>{
      this.CustomerApp=res.data
    })
    }
    else{
      this.customerService.CustomerAppSearch(this.count,this.search).subscribe((res)=>{
        this.CustomerApp=res.data;
      })

    }
  }
  //-------function for click next-------
  clicks_next(){
    this.count=this.count+1
    if(this.search_flag==true){
      this.customerService.CustomerAppSearch(this.count,this.search).subscribe((res)=>{
        this.next_output=res.data
        if(this.next_output.length!=0){
          this.CustomerApp=this.next_output;
          this.New_count=this.count;
        }
      })
    }
    else{
    this.customerService.GetCustomerApp(this.count).subscribe((res)=>{
      this.next_output=res.data
      if(this.next_output.length!=0){
        this.CustomerApp=this.next_output;
        this.New_count=this.count;
      }
    })
  }
  }
  ngOnInit(): void {
    this.customerService.GetCustomerApp(this.count).subscribe((res)=>{
      this.CustomerApp=res.data
      this.CardShown=true;
      this.loaderShown=false;
    })
  }

}
